export default __webpack_public_path__ + "static/media/HOT STAMPING JIG.46c2c21b.png";